export default __webpack_public_path__ + "static/media/east.60be9576.jpeg";